// SignupSuccess Component
// Displayed after successful signup with next steps guidance

import React from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from 'app/store';

const SignupSuccess: React.FC = () => {
  const { journeyConfig } = useSelector((state: RootState) => state.signup);

  return (
    <div className="text-center">
      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="mt-4 text-lg font-medium text-gray-900">Account created successfully!</h3>
      <p className="mt-2 text-sm text-gray-600">We&apos;ve sent you an email with a link to set your password.</p>
      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h4 className="text-sm font-medium text-blue-900 mb-2">Next steps:</h4>
        <ol className="text-left text-sm text-blue-800 space-y-2">
          <li className="flex items-start">
            <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-blue-100 text-blue-600  mr-2">
              1
            </span>
            <span>Check your email and click the password setup link</span>
          </li>
          <li className="flex items-start">
            <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-blue-100 text-blue-600  mr-2">
              2
            </span>
            <span>Set your password and log in</span>
          </li>
          <li className="flex items-start">
            <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-blue-100 text-blue-600  mr-2">
              3
            </span>
            <span>Configure your Snowflake account</span>
          </li>
          <li className="flex items-start">
            <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-blue-100 text-blue-600  mr-2">
              4
            </span>
            <span>
              {journeyConfig?.app_variant === 'cicd'
                ? 'Start automating your data pipeline deployments!'
                : 'Start building your data pipelines!'}
            </span>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default SignupSuccess;
